import Autolink from "autolinker"

function escapeHTML(text: string): string {
	return text
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;")
}

// Autolinker passes markup through untouched, so user text is escaped first and
// only the anchors Autolinker generates are real HTML.
function linkifyText(text: string): string {
	return Autolink.link(escapeHTML(text))
}

export {escapeHTML, linkifyText}
